import { RelType } from './LinkUtils.js';
export var IProjectPatchKeys;
(function (IProjectPatchKeys) {
    IProjectPatchKeys["GRADIENT_ID"] = "/project:rendition/gradientId";
})(IProjectPatchKeys || (IProjectPatchKeys = {}));
export var ProjectViews;
(function (ProjectViews) {
    /**
     * Combination of Projects returned from yours and sharedWithYou.
     */
    ProjectViews[ProjectViews["All"] = 0] = "All";
    /**
     *  Only the Projects that are considered yours:
     *  For CCI profile, only the projects within /projects directory are returned.
     *  For CCT/CCE profile, a combination of projects within the assigned user storage for the profile,
     *  and the shared storage of Org are returned. If the profile only has access to the
     *  Project via inheritance or through orgEverybody group, then it will not be included.
     */
    ProjectViews[ProjectViews["Yours"] = 1] = "Yours";
    /**
     * Only the Projects that are shared with the requestor. For both CCI and CCT/CCE profiles,
     * the collection would be the negation of yours with the exception that the Projects shared
     * via orgEverybody group are still not included.
     */
    ProjectViews[ProjectViews["SWY"] = 2] = "SWY";
    /**
     * The full list of Projects regardless of how it is accessed. This includes Projects accessible
     * via inheritance and shared via orgEverybody group.
     */
    ProjectViews[ProjectViews["Admin"] = 3] = "Admin";
    /**
     * All projects that match a particluar organization specified in ProjectFilter.organizationID
     */
    ProjectViews[ProjectViews["Organization"] = 4] = "Organization";
    /**
     * The list of recent projects. This is determined by the lastAccessedDate of the project.
     */
    ProjectViews[ProjectViews["Recent"] = 5] = "Recent";
})(ProjectViews || (ProjectViews = {}));
export var ProjectCapabilities;
(function (ProjectCapabilities) {
    ProjectCapabilities["CREATE"] = "create";
})(ProjectCapabilities || (ProjectCapabilities = {}));
export var ProjectLeaveReason;
(function (ProjectLeaveReason) {
    ProjectLeaveReason[ProjectLeaveReason["PENDING"] = 0] = "PENDING";
    ProjectLeaveReason[ProjectLeaveReason["CAN_LEAVE"] = 1] = "CAN_LEAVE";
    /**
     * All false reasons.
     */
    ProjectLeaveReason[ProjectLeaveReason["CANNOT_LEAVE_NO_COLLABORATORS"] = 2] = "CANNOT_LEAVE_NO_COLLABORATORS";
    ProjectLeaveReason[ProjectLeaveReason["CANNOT_LEAVE_ADDRESS_BOOK_GROUP_MEMBER"] = 3] = "CANNOT_LEAVE_ADDRESS_BOOK_GROUP_MEMBER";
    ProjectLeaveReason[ProjectLeaveReason["CANNOT_LEAVE_LAST_COLLABORATOR"] = 4] = "CANNOT_LEAVE_LAST_COLLABORATOR";
    /**
     * @deprecated -- will be and removed on or after 2024-10-01.
     */
    ProjectLeaveReason[ProjectLeaveReason["CANNOT_LEAVE_LAST_DIRECT_COLLABORATOR"] = 5] = "CANNOT_LEAVE_LAST_DIRECT_COLLABORATOR";
    ProjectLeaveReason[ProjectLeaveReason["CANNOT_LEAVE_IS_ADMIN_OF_PROJECT"] = 6] = "CANNOT_LEAVE_IS_ADMIN_OF_PROJECT";
    ProjectLeaveReason[ProjectLeaveReason["CANNOT_LEAVE_LAST_DIRECT_COLLAB_WITH_SHARE_PERMISSION"] = 7] = "CANNOT_LEAVE_LAST_DIRECT_COLLAB_WITH_SHARE_PERMISSION";
    ProjectLeaveReason[ProjectLeaveReason["CANNOT_LEAVE_IS_OWNER"] = 8] = "CANNOT_LEAVE_IS_OWNER";
})(ProjectLeaveReason || (ProjectLeaveReason = {}));
/**
 * Reasons for why the user can or cannot create a project.
 */
export var CanCreateProjectReason;
(function (CanCreateProjectReason) {
    CanCreateProjectReason[CanCreateProjectReason["UNKNOWN"] = 0] = "UNKNOWN";
    CanCreateProjectReason[CanCreateProjectReason["ALLOWED"] = 1] = "ALLOWED";
    CanCreateProjectReason[CanCreateProjectReason["ADMIN_DISABLED"] = 2] = "ADMIN_DISABLED";
    CanCreateProjectReason[CanCreateProjectReason["INVALID_REPOSITORY"] = 3] = "INVALID_REPOSITORY";
    CanCreateProjectReason[CanCreateProjectReason["NO_HOME_REPOSITORY"] = 4] = "NO_HOME_REPOSITORY";
})(CanCreateProjectReason || (CanCreateProjectReason = {}));
/**
 * The enumerated values for the `project:directorySubType` metadata field.
 */
export var ProjectDirectorySubtype;
(function (ProjectDirectorySubtype) {
    ProjectDirectorySubtype["WF_PORTFOLIO"] = "wfPortfolio";
    ProjectDirectorySubtype["WF_PROGRAM"] = "wfProgram";
    ProjectDirectorySubtype["WF_PROJECT"] = "wfProject";
    ProjectDirectorySubtype["WF_TEMPLATE"] = "wfProjectTemplate";
    ProjectDirectorySubtype["CC_PROJECTS"] = "ccProject";
})(ProjectDirectorySubtype || (ProjectDirectorySubtype = {}));
